import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "资讯", to: "/news" },
  { label: "作品", to: "/works" },
  { label: "个人资料", to: "/profile" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    setOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">
            白
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg text-foreground-950 tracking-wide">
              白石茉莉奈
            </span>
            <span className="text-[10px] tracking-[0.25em] text-foreground-400 font-body">
              MARINA SHIRAISHI
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-sm font-body transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-primary-600 font-semibold"
                    : "text-foreground-600 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <form onSubmit={submitSearch} className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索资讯 / 作品"
              className="w-52 text-sm font-body bg-background-100 border border-background-200 rounded-md pl-9 pr-3 py-2 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
            />
          </form>
          <Link
            to="/search"
            className="w-10 h-10 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center hover:bg-secondary-600 transition-colors cursor-pointer shrink-0"
            aria-label="进入搜索页"
          >
            <i className="ri-search-2-line"></i>
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block px-3 py-2.5 rounded-md text-sm font-body ${
                  isActive
                    ? "bg-primary-50 text-primary-700 font-semibold"
                    : "text-foreground-700 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <form onSubmit={submitSearch} className="pt-2">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯 / 作品"
                className="w-full text-sm font-body bg-background-100 border border-background-200 rounded-md pl-9 pr-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-primary-300"
              />
            </div>
          </form>
        </div>
      )}
    </header>
  );
}